import create from "zustand";
import produce from "immer";

const STORE = {
  rows: {}
};

const createWithImmer = (storeCreator) =>
  create((originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );

export const useSignStore = createWithImmer((setState, getState) => ({
  ...STORE,
  updateSignatureData: (rowId, columnId, data) => {
    let rows = {
      ...getState().rows
    };
    if (!rows[rowId]) {
      rows[rowId] = {};
    } else {
      rows[rowId] = { ...rows[rowId] };
    }
    if (!rows[rowId][columnId]) {
      rows[rowId][columnId] = {};
    }
    rows[rowId][columnId] = { data: data };
    setState(() => {
      return { rows: rows };
    });
  },
  clearCellValue: (rowId, columnId) => {
    getState().updateSignatureData(rowId, columnId, "");
  },
  getSignatureData: (rowId, columnId) => {
    let rows = getState().rows;
    // let url;
    // return Object.keys(rows).map((row) => {
    //   if (row === rowId) {
    //     Object.keys(rows[row]).map((column) => {
    //       if (column === columnId) {
    //         url = rows[row][column].data;
    //       }
    //       return url;
    //     });
    //   }
    //   return url;
    // });
    return rows[rowId] && rows[rowId][columnId] && rows[rowId][columnId].data;
  }
}));
